import React, { Fragment, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ActionButton } from './ActionButton';
function useCountdown() {
  const [seconds, setSeconds] = useState(23 * 3600 + 55 * 60 + 21);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(value => String(value).padStart(2, '0'));
}
interface PricingProps {
  showAnchor?: boolean;
}
export function Pricing({
  showAnchor = false
}: PricingProps) {
  const [hours, minutes, seconds] = useCountdown();
  return <section id={showAnchor ? 'pricing' : undefined} className="bg-brand-dark" data-id="element-97" data-mp="20sv9sqjjzuzx">
      <div className="bg-[#1c0909] px-4 py-16 sm:py-20" data-id="element-98" data-mp="3h74lak2p5p9c">
        <div className="mx-auto max-w-4xl text-center" data-id="element-99" data-mp="3h5jriwo7iacj">
          <h2 className="font-display text-xl font-bold sm:text-2xl" data-id="element-100" data-mp="3c8tfqljfq0wx">PRECIO DE LANZAMIENTO — CIERRA EN:</h2>
          <div className="mt-6 flex justify-center gap-3 sm:gap-6" data-id="element-101" data-mp="3w08ggest1ydj">
            {[[hours, 'HS'], [minutes, 'MIN'], [seconds, 'SEG']].map(([value, label], index) => <Fragment key={label} data-id="element-102" data-mp="4uytyx40s28o" data-mpi={index}>
                <div data-id="element-103" data-mp="9rz0ta8p190u">
                  <p className="font-display text-5xl font-bold text-red-500 sm:text-7xl" data-id="element-104" data-mp="9tju6wj9ulx4">{value}</p>
                  <p className="text-xs tracking-[.2em] text-slate-400" data-id="element-105" data-mp="eq0m81tldkfh">{label}</p>
                </div>
                {index < 2 && <span className="pt-2 font-display text-4xl text-red-500 sm:text-6xl" data-id="element-106" data-mp="3dasavd29jfq9">:</span>}
              </Fragment>)}
          </div>
          <p className="mt-6 text-slate-400" data-id="element-107" data-mp="3n7euxzmrm2r8">Después sube. <b className="text-white" data-id="element-108" data-mp="3n5k8uhzrc4lk">No vuelve.</b></p>
          <div className="mx-auto mt-5 max-w-md rounded-xl border border-red-500/20 bg-brand-ink p-4 text-left" data-id="element-109" data-mp="3rxlirx9gdj8f">
            <div className="flex justify-between text-sm font-medium text-red-400" data-id="element-110" data-mp="2uj99tbrsubqv"><span data-id="element-111" data-mp="2zhkj9le6mk8k">Cupos al precio de lanzamiento</span><span data-id="element-112" data-mp="2zgiwwkrpubbj">Quedan pocos</span></div>
            <div className="mt-3 h-2.5 overflow-hidden rounded-full bg-slate-800" data-id="element-113" data-mp="2zfg8qkls2mzb"><div className="h-full w-[68%] rounded-full bg-red-500" data-id="element-114" data-mp="2rfjuj9slggki" /></div>
            <p className="mt-2 text-right text-xs text-slate-500" data-id="element-115" data-mp="2mijp913kjhug">68% de los cupos ya tomados</p>
          </div>
        </div>
      </div>

      <div className="px-4 py-16 sm:py-24" data-id="element-116" data-mp="315wf320es9qn">
        <div className="mx-auto max-w-2xl" data-id="element-117" data-mp="2w7utoafifyc0">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-118" data-mp="2w839ob6xjjrf">TU SISTEMA COMPLETO</h2>
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-8 rounded-3xl border-2 border-brand-green bg-brand-ink p-6 shadow-[0_0_30px_rgba(22,163,74,.13)] sm:p-9" data-id="element-119" data-mp="28i8zy2hwqbbe">
            <div className="flex flex-col gap-4 sm:flex-row sm:justify-between" data-id="element-120" data-mp="2dh3j55jse1w1">
              <div data-id="element-121" data-mp="2djg842nypcil">
                <h3 className="font-display text-lg font-bold text-brand-light" data-id="element-122" data-mp="3tv3ee37ot3cy">🟢 SISTEMA: ESTÓMAGO BAJO CONTROL™</h3>
                <p className="mt-1 text-sm text-slate-400" data-id="element-123" data-mp="3ox1szbmsgryb">5 Volúmenes + 5 Bonos · Acceso inmediato · 100% PDF</p>
                <p className="mt-3 text-sm text-brand-light" data-id="element-124" data-mp="9cburhpfh3x">Tu sistema completo en PDF + 5 bonos estratégicos de regalo.</p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-125" data-mp="5740ncn1yn3w">
                <p className="text-slate-500 line-through" data-id="element-126" data-mp="3ngelvqj26y3e">$65.000</p>
                <p className="font-display text-4xl font-bold text-brand-light" data-id="element-127" data-mp="3rg577eptgm0j">$19.990</p>
                <p className="text-xs text-slate-400" data-id="element-128" data-mp="j153ahh4ku9j">ARS</p>
              </div>
            </div>
          </motion.div>
          <ActionButton href="https://sistema-estomago-bajo-control.impultienda.ar/checkout" className="mt-7" showTrust data-id="element-129" data-mp="o07xf6vkhg2q">QUIERO MI SISTEMA AHORA</ActionButton>
        </div>
      </div>
    </section>;
}